<template>
    <section class="services-wrapper">
        <div class="s-top-shape1"></div>
        <div class="s-top-shape2"></div>
        <div class="s-bot-shape1"></div>
        <div class="s-bot-shape2"></div>
        <div class="s-top-shape4"></div>
        <div class="s-bot-shape4"></div>
        <article class="services-desc">
            <span class="h-s-span1">
                {{$t("Home.Services.span1")}}
            </span>
            <span class="h-s-span2">
                {{$t('Home.Services.span2')}}
            </span>
        </article>
        <div class="cards">
            <ul>
                <li>
                    <v-card elevation="5" class="mx-auto my-12" max-width="374">

                        <div class="photo-malowanie" style="height:250px;width:374px;background-size: cover;background-position: center;"></div>
                    
                        <v-card-title>{{$t('Home.Services.painting')}}</v-card-title>
                    
                        <v-card-text>
                            {{$t('Home.Services.painting-span1')}}
                        </v-card-text>
                        <v-divider class="mx-4"></v-divider>
                        <v-card-text>{{$t('Home.Services.painting-span2')}}</v-card-text>
                    
                        <v-divider class="mx-4"></v-divider>
                        <v-card-actions style="display: flex; justify-content: space-evenly">
                            <v-btn color="#10424b" outlined text>
                                {{$t('Home.Services.btn1')}}
                            </v-btn>
                            <v-btn color="#10424b" outlined text>
                                {{$t('Home.Services.btn2')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </li>
                <li>
                    <v-card elevation="5" class="mx-auto my-12" max-width="374">
                        <div class="photo-rusztowanie" style="height:250px;width:374px;background-size: cover;background-position: center;"></div>
                    
                        <v-card-title>{{$t('Home.Services.scaffolding')}}</v-card-title>
                    
                        <v-card-text>
                            {{$t('Home.Services.scaffolding-span1')}}
                        </v-card-text>
                        <v-divider class="mx-4"></v-divider>
                        <v-card-text>{{$t('Home.Services.scaffolding-span2')}}</v-card-text>
                    
                        <v-divider class="mx-4"></v-divider>
                        <v-card-actions style="display: flex; justify-content: space-evenly">
                            <v-btn color="#10424b" outlined text>
                                {{$t('Home.Services.btn1')}}
                            </v-btn>
                            <v-btn color="#10424b" outlined text>
                                {{$t('Home.Services.btn2')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </li>
                <li>
                    <v-card elevation="5" class="mx-auto my-12" max-width="374">
                    
                        <div class="photo-spawanie" style="height:250px;width:374px;background-size: cover;background-position: center;"></div>
                    
                        <v-card-title>{{$t('Home.Services.welding')}}</v-card-title>
                    
                        <v-card-text>
                            {{$t('Home.Services.welding-span1')}}
                        </v-card-text>
                        <v-divider class="mx-4"></v-divider>
                        <v-card-text>{{$t('Home.Services.welding-span2')}}</v-card-text>
                    
                        <v-divider class="mx-4"></v-divider>
                        <v-card-actions style="display: flex; justify-content: space-evenly">
                            <v-btn color="#10424b" outlined text>
                                {{$t('Home.Services.btn1')}}
                            </v-btn>
                            <v-btn color="#10424b" outlined text>
                                {{$t('Home.Services.btn2')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {
    name: 'home-services'
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}

@mixin mobileBig {
    @media only screen and (max-width: 1400px) {
        @content;
    }
}
$shape-color: rgb(242, 242, 242);
.services-wrapper {
    background-color: white;
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    color: #10424b;
    .s-top-shape1 {
        margin: 150px 0 0 0;
        position: absolute;
        width: 150px;
        height: 200px;
        background-color: $shape-color;
        transform: skew(20deg);
        @include mobile {
            width: 80px;
        }        
    }
    .s-bot-shape1 {
        margin: 350px 0 0 0;
        position: absolute;
        width: 150px;
        height: 200px;
        background-color: $shape-color;
        transform: skew(-20deg);
            @include mobile {
                width: 80px;
            }
    }
    .s-top-shape2 {
        margin: 150px 0 0 40%;
        position: absolute;
        width: 150px;
        height: 200px;
        background-color: $shape-color;
        transform: skew(20deg);
            @include mobile {
                width: 80px;
            }
    }
    .s-bot-shape2 {
        margin: 350px 0 0 40%;
        position: absolute;
        width: 150px;
        height: 200px;
        background-color: $shape-color;
        transform: skew(-20deg);
            @include mobile {
                width: 80px;
            }
    }
    .s-top-shape4 {
        right: 100px;
        margin: 150px 0 0 40%;
        position: absolute;
        width: 150px;
        height: 200px;
        background-color: $shape-color;
        transform: skew(20deg);
            @include mobile {
                width: 80px;
                left: 150px;
            }
    }
    .s-bot-shape4 {
        right: 100px;
        margin: 350px 0 0 40%;
        position: absolute;
        width: 150px;
        height: 200px;
        background-color: $shape-color;
        transform: skew(-20deg);
        @include mobile {
            width: 80px;
            left: 150px;
        }        
    }
    .services-desc {
        margin: 50px 0 0 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 2;
        .h-s-span1 {
            font-size: 46px;
            @include mobile {
                font-size: 36px;
            }
        }
        .h-s-span2 {
            margin: 20px 0 0 0;
            font-size: 24px;
            width: 60%;
            @include mobile {
                font-size: 20px;
            }
        }
    }
    .cards {
        margin: 20px 0 0 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        ul {
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin: 0;
            padding: 0;
            li {
                margin: 30px;
                list-style-type: none;
                @include mobile {
                    margin: 0;
                }
            }
        }
    }
}
.photo-malowanie {
    background-image: url('../../../public/img/1.jpg');
}
.photo-spawanie {
    background-image: url('../../../public/img/zdj_spawanie.jpg');
}
.photo-rusztowanie {
    background-image: url('../../../public/img/zdj_rusztowanie.jpg');
}
</style>